<template>
  <div class="login-box">
    <div class="content">
      <img class="logo" src="@/assets/image/logo.png" alt="" />
      <div class="form-box">
        <div class="input-item">
          <van-icon class="icon" name="manager" />
          <input
            v-model="fromData.mobile"
            type="text"
            placeholder="请输入账户名"
          />
        </div>
        <div class="input-item">
          <van-icon class="icon" name="lock" />
          <input
            v-model="fromData.password"
            type="password"
            placeholder="请输入密码"
          />
        </div>
      </div>
      <button class="sub-btn" @click="onLogin">登录</button>
      <div class="register-box">
        <div @click="onWxLogin">立即注册</div>
        <!-- <router-link to="/EditPassword">忘记密码</router-link> -->
      </div>
      <van-divider
        :style="{
          color: '#666',
          borderColor: '#999999',
          padding: '0 16px',
          width: '100%',
        }"
      >
        其他登录方式
      </van-divider>
      <div class="btns">
        <div class="btn" @click="onWxLogin">
          <img src="@/assets/image/wx_01.png" alt="" />
          <span>微信登录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addOp } from "../../api";
import base from "../../api/base";
import { getUser, login } from "../../utils/login";
export default {
  data() {
    return {
      fromData: {},
      loginURL: base.loginURL,
    };
  },
  created() {
    var token = this.$cookies.get("Authorization");
    var code = this.getUrlKey("code");
    var state = this.getUrlKey("state");
    if (code && state) {
      login();
    }
  },
  methods: {
    onLogin() {
      var _this = this;
      _this.$toast.loading({
        message: "",
        forbidClick: true,
      });
      if (_this.fromData.mobile == undefined) {
        _this.$toast("手机号不能为空！");
        return;
      }
      if (_this.fromData.password == undefined) {
        _this.$toast("密码不能为空！");
        return;
      }
      addOp("/oauth/user_login", _this.fromData).then(async (res) => {
        if (res && res.status == 200) {
          _this.$toast.success("登录成功！");
          _this.$cookies.set(
            "Authorization",
            res.data.token_type + " " + res.data.access_token
          );
          _this.$cookies.set("login_type", res.data.login_type);
          await getUser();
          // setTimeout(() => {
          //   _this.$router.go(-1);
          // }, 800);
        } else {
          if (res.data.errors) {
            for (var key in res.data.errors) {
              _this.$toast.fail(res.data.errors[key][0]);
            }
          } else {
            _this.$toast.fail("登陆失败，请重试！");
          }
        }
      });
    },
    onWxLogin() {
      var _this = this;
      window.location.href = _this.loginURL;
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
  },
};
</script>

<style>
</style>